import { useMemo } from "react";
import { DataTable, Pagination } from "@/components/molecules";
import { usePagination, useProfile } from "@/hooks";
import { useAppSelector } from "@/redux/hooks";
import { clsx } from "@/utils";
import { generateData, generateColumns } from "./helpers";
import { UserAccountHistory } from "@/redux/slices/userAccount/types";
import { userAccountHistoryPageSelector } from "@/redux/slices/userAccount/selectors";

interface UserAccountHistoryTableProps extends React.HTMLAttributes<HTMLDivElement> {
  items: UserAccountHistory[];
}

export const UserAccountHistoryTable = ({ items, className, ...props }: UserAccountHistoryTableProps) => {
  const { dateFormat, timeFormat } = useProfile();

  const data = useMemo(
    () => generateData(items, dateFormat, timeFormat),
    [dateFormat, items, timeFormat]
  );
  const columns = useMemo(() => generateColumns(), []);

  return (
    <div className={clsx("relative flex", className)}>
      <DataTable 
        className="[&_table]:table-auto overflow-x-auto w-full"
        columns={columns} 
        data={data} 
        {...props} 
      />
    </div>
  );
};

const UserAccountHistoryTablePagination = () => {
  const { current, count, total, size } = useAppSelector(userAccountHistoryPageSelector);
  const { handlePageClick, handleSizeChange } = usePagination();

  return (
    <Pagination
      className="w-full overflow-x-auto [&_table]:table-auto"
      onPageClick={handlePageClick}
      onSizeChange={handleSizeChange}
      currentPage={current}
      pageSize={size}
      totalItems={total}
      pageCount={count}
    />
  );
};

UserAccountHistoryTable.Pagination = UserAccountHistoryTablePagination;
